import type { AssetAddButtonProps } from "./asset-add-button.type";

import AssetCreate from "@/features/Assets/Create";
import ModelAddButton from "@/modules/model-add-button";

const AssetAddButton = ({
  ancestors = [],
  defaultCoordinate,
  ...options
}: AssetAddButtonProps) => {
  return (
    <ModelAddButton
      model="asset"
      component={
        <AssetCreate
          ancestors={ancestors}
          defaultCoordinate={defaultCoordinate}
        />
      }
      {...options}
    />
  );
};

export default AssetAddButton;
